<template>
  <div>
    <section class="page_box">
      <img :src="bannerImgUrl" alt="" />
    </section>
    <div id="bigBox">
      <section class="page_nav" :class="{ fixed: navFixed }">
        <ul>
          <li
            :class="{ active: activeNav === 0 }"
            @click="navClick(0, 'conpany_box')"
          >
            企业介绍
          </li>
          <li
            :class="{ active: activeNav === 1 }"
            @click="navClick(1, 'strategy_box')"
          >
            战略布局
          </li>
          <li
            :class="{ active: activeNav === 2 }"
            @click="navClick(2, 'honor_box')"
          >
            荣誉资质
          </li>
          <li
            :class="{ active: activeNav === 3 }"
            @click="navClick(3, 'future_box')"
          >
            数智新时代·AI联未来
          </li>
          <li
            :class="{ active: activeNav === 4 }"
            @click="navClick(4, 'history_box')"
          >
            发展历程
          </li>
        </ul>
      </section>
      <!-- 企业介绍 -->
      <section class="conpany_box module_box" id="conpany_box">
        <h1 class="main_title">企业介绍</h1>
        <div class="conpany_info sub_module_box">
          <div class="conpany_left">
            <h2>河南省润信数字智能科技有限公司</h2>
            <p>
              河南省润信数字智能科技有限公司成立于2020年，专注中国企业数智化经营管理转型与阿里巴巴&钉钉深度合作的一站式企业数智化解决方案专家。公司以“Al+123"为核心战略，立足企业数智化经营管理转型核心业务，依托互联网新媒体、电商业务两大增长引擎，辅以全流程落地、全渠道覆盖、全周期赋能三大保障，以AI技术贯穿全链路，为企业提供降本增效的数智化增长一站式解决方案。
            </p>
            <ul class="conpany_ul">
              <li>
                <div class="li_title">
                  <div>10</div>
                  <span>年</span>
                </div>
                <p>系统开发经验</p>
              </li>
              <li>
                <div class="li_title">
                  <div>36</div>
                  <span>项</span>
                </div>
                <p>软件著作权</p>
              </li>
              <li>
                <div class="li_title">
                  <div>30</div>
                  <span>家</span>
                </div>
                <p>合作百强企业</p>
              </li>
              <li>
                <div class="li_title">
                  <div>1000</div>
                  <span>+</span>
                </div>
                <p>服务客户</p>
              </li>
            </ul>
          </div>
          <img :src="$utils.formatImgUrl('businessImg1.png')" alt="" />
        </div>
      </section>
      <!-- 战略布局 -->
      <section class="strategy_box module_box" id="strategy_box">
        <h1 class="main_title">战略布局</h1>
        <div class="sub_module_box">
          <img :src="$utils.formatImgUrl('AI123Img.png')" alt="战略布局" />
        </div>
      </section>
      <!-- 荣誉资质 -->
      <section class="honor_box module_box" id="honor_box">
        <h1 class="main_title">荣誉资质</h1>
        <div
          class="honor_info sub_module_box"
          :style="
            'background: url(' +
            $utils.formatImgUrl('bgImg.png') +
            ') no-repeat center center;background-size: 100% 100%;'
          "
        >
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item, index) in 5" :key="index">
                <img :src="$utils.formatImgUrl('zizhi3.png')" alt="" />
              </div>
            </div>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
          </div>
        </div>
      </section>
      <!-- 数智新时代·AI联未来 -->
      <section class="future_box module_box" id="future_box">
        <h1 class="main_title">数智新时代·AI联未来</h1>
        <div class="future_info sub_module_box">
          <img :src="$utils.formatImgUrl('img2.png')" alt="" />
          <ul class="future_ul">
            <li>
              <img src="../../assets/img/conpany_icon1.png" alt="" />
              <div class="li_content">
                <h2>企业使命</h2>
                <p>数智化+Al让企业经营更轻松</p>
              </div>
            </li>
            <li>
              <img src="../../assets/img/conpany_icon2.png" alt="" />
              <div class="li_content">
                <h2>企业愿景</h2>
                <p>成为中国企业数智化AI经营管理变革的推动者</p>
              </div>
            </li>
            <li>
              <img src="../../assets/img/conpany_icon3.png" alt="" />
              <div class="li_content">
                <h2>企业价值观</h2>
                <p>爱国敬业 诚信/对标创新进化/快乐担当感恩</p>
              </div>
            </li>
          </ul>
        </div>
      </section>
      <!-- 发展历程 -->
      <section class="history_box module_box" id="history_box">
        <h1 class="main_title">发展历程</h1>
        <div class="history_info sub_module_box">
          <div class="history_top">
            <img :src="historyItem.imgUrl" alt="" />
            <div>
              <h2>{{ historyItem.date }}</h2>
              <span></span>
              <p>
                {{ historyItem.desc }}
              </p>
            </div>
          </div>
          <ul class="history_list">
            <li
              v-for="(item, index) in historyList"
              :key="index"
              @click="handleHistoryClick(index, item)"
              :class="{ active: activeIndex === index }"
            >
              <div>
                <img :src="item.imgUrl" alt="" />
              </div>
              <p>{{ item.date }}</p>
            </li>
          </ul>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "Company",
  components: {},
  data() {
    return {
      bannerImgUrl: "",
      conpanyInfo: {
        conpanyName: "企业名称",
        conpanyDesc: "描述",
        conpanyImg: "http...", //企业封面图
        conpanyStory: [
          { time: "", title: "" },
          { time: "", title: "" },
          { time: "", title: "" },
        ],
      },
      historyItem: {
        id: 1,
        date: "2023年09月26日",
        desc: "公司正式注册成立，初始名称为“济源市润信科技有限公司”",
        imgUrl: "",
      },
      historyList: [
        {
          id: 1,
          date: "2023年09月26日",
          desc: "公司正式注册成立，初始名称为“济源市润信科技有限公司”",
          imgUrl: "",
        },
        {
          id: 2,
          date: "2024年10月31日",
          desc: "完成首次对外投资，在杭州设立全资子公司润信北软数字智能科技(杭州)有限公司",
          imgUrl: "",
        },
        {
          id: 3,
          date: "2025年04月17日",
          desc: "由“济源市润信科技有限公司”正式更名为“河南省润信数字智能科技有限公司”",
          imgUrl: "",
        },
        {
          id: 4,
          date: "2025年05月21日",
          desc: "完成第二次对外投资，在郑州参股设立河南省深眸机器人科技有限公司(持股30%)，进军机器人与AI领域，完善技术生态链",
          imgUrl: "",
        },
        {
          id: 5,
          date: "2025年12月",
          desc: "完成经营地址变更与内部章程调整，公司运营进一步规范化",
          imgUrl: "",
        },
        {
          id: 6,
          date: "2026年4月",
          desc: "形成以济源总部为核心，杭州、郑州为两翼的 “一总部两分支” 布局",
          imgUrl: "",
        },
      ],
      honor: ["http...", "http..."],
      activeIndex: 0,
      navFixed: false,
      navTop: 0,
      activeNav: 0,
    };
  },
  created() {},
  beforeMount() {
    this.bannerImgUrl = JSON.parse(
      localStorage.getItem("imgUrlList"),
    ).web_business[0].image;
  },
  mounted() {
    this.historyList = this.historyList.map((item, index) => {
      if (index + 1 == 2 || index + 1 == 4) {
        item.imgUrl = this.$utils.formatImgUrl(`historyImg${index + 1}.png`);
      } else {
        item.imgUrl = this.$utils.formatImgUrl(`historyImg${index + 1}.jpg`);
      }
      return item;
    });

    this.historyItem.imgUrl = this.historyList[0].imgUrl;
    // 你的swiper不动 保持原样
    new this.$Swiper(".swiper-container", {
      slidesPerView: 3,
      spaceBetween: 30,
      centeredSlides: true,
      initialSlide: 1, // 默认显示第二个slide
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      keyboard: true,
    });

    // 添加滚动事件监听
    window.addEventListener("scroll", this.handleScroll);

    // 获取page_nav元素的初始位置，确保DOM完全渲染后再获取
    setTimeout(() => {
      const navElement = document.querySelector(".page_nav");
      if (navElement) {
        this.navTop = navElement.offsetTop;
        // 页面刷新后检查滚动位置，更新导航栏状态
        this.handleScroll();
      }
    }, 100);
  },
  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleHistoryClick(index, item) {
      // 更新activeIndex
      this.activeIndex = index;
      // 更新historyItem数据
      this.historyItem = {
        id: item.id,
        date: item.date,
        desc: item.desc,
        iconUrl: item.iconUrl,
        imgUrl: item.imgUrl,
      };
    },
    navClick(index, targetId) {
      // 更新激活状态
      this.activeNav = index;
      // 标记正在滚动，防止滚动事件触发
      this.isScrolling = true;
      // 滚动到对应模块
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        // 计算滚动位置，考虑固定导航栏的高度
        const navHeight = 90; // 顶部导航栏高度
        const pageNavHeight = 80; // page_nav高度
        const rect = targetElement.getBoundingClientRect();
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        const offsetTop = rect.top + scrollTop - navHeight - pageNavHeight; // 20为额外间距

        // 平滑滚动到指定位置
        window.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });

        // 滚动结束后重置标记
        setTimeout(() => {
          this.isScrolling = false;
        }, 1000); // 1秒后滚动应该完成
      }
    },
    handleScroll() {
      // 获取滚动位置
      const scrollTop = window.scrollY;

      // 只有当navTop被正确设置后才进行导航栏状态判断
      if (this.navTop > 0) {
        // 处理page_nav固定定位
        if (scrollTop >= this.navTop - 90) {
          // 90是顶部导航栏的高度
          this.navFixed = true;
        } else {
          this.navFixed = false;
        }

        // 处理顶部导航栏显示/隐藏
        const myNav = document.querySelector(".my_nav");
        if (myNav) {
          if (this.navFixed) {
            myNav.style.opacity = "0";
            myNav.style.transform = "translateY(-100%)";
            myNav.style.transition = "all 0.3s ease";
          } else {
            myNav.style.opacity = "1";
            myNav.style.transform = "translateY(0)";
            myNav.style.transition = "all 0.3s ease";
          }
        }
      }

      // 检测当前滚动位置对应的模块，更新导航激活状态
      if (!this.isScrolling) {
        const modules = [
          { id: "conpany_box", index: 0 },
          { id: "strategy_box", index: 1 },
          { id: "honor_box", index: 2 },
          { id: "future_box", index: 3 },
          { id: "history_box", index: 4 },
        ];

        const navHeight = 90; // 顶部导航栏高度
        const pageNavHeight = 80; // page_nav高度
        const offset = navHeight + pageNavHeight + 20; // 偏移量

        for (const module of modules) {
          const element = document.getElementById(module.id);
          if (element) {
            const rect = element.getBoundingClientRect();
            // 当模块顶部进入可视区域时，更新激活状态
            if (rect.top <= offset && rect.bottom >= offset) {
              this.activeNav = module.index;
              break;
            }
          }
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
.conpany_box,
.future_box,
.history_box,
.honor_box,
.strategy_box {
  width: 100%;
  padding: 0 8%;
  box-sizing: border-box;
}
.strategy_box img {
  width: 100%;
}
.conpany_box .conpany_info {
  width: 100%;
  display: flex;
  justify-content: space-between;

  .conpany_left {
    width: 50%;
    text-align: left;
    overflow: hidden;
    > h2 {
      font-size: 1.5rem;
      font-weight: 400;
      color: rgba(9, 15, 25, 1);
    }
    > p {
      font-size: 0.875rem;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      margin: 30px 0;
      line-height: 26px;
      letter-spacing: 1px;
      text-indent: 2rem;
    }
    > ul {
      display: flex;
      justify-content: space-between;
      > li {
        width: 24%;
        height: 120px;
        background: url("../../assets/img/conpany_bg_icon.png") no-repeat center
          center;
        background-size: 100% 100%;
        text-align: center;

        .li_title {
          display: flex;
          justify-content: center;
          align-items: baseline;
          color: rgba(7, 70, 255, 1);
          > div {
            font-size: 1.875rem;
          }
          > span {
            font-size: 1rem;
          }
        }
        > p {
          font-size: 0.75rem;
          color: rgba(102, 102, 102, 1);
          margin-top: 6px;
        }
      }
    }
  }

  > img {
    width: 46%;
  }
}
.honor_info {
  width: 100%;
  height: 554px;
  display: flex;
  align-items: center;

  .swiper-container {
    width: 100%;
    height: 340px;
  }
  .swiper-slide {
    width: 534px;
    height: 340px;

    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    transition: 300ms;
    transform: scale(0.8);

    > img {
      width: 100%;
    }
  }
  .swiper-slide-active,
  .swiper-slide-duplicate-active {
    transform: scale(1.2);
  }
  /* 自定义箭头样式 */
  .swiper-button-next,
  .swiper-button-prev {
    width: 40px;
    height: 40px;
    background: #000;
    border-radius: 50%;
    margin-top: -25px;
  }
  .swiper-button-next::after,
  .swiper-button-prev::after {
    content: "";
    display: block;
    width: 8px;
    height: 8px;
    border: 2px solid #fff;
    border-left: none;
    border-bottom: none;
    transform: rotate(45deg);
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .swiper-button-next::after {
    transform: rotate(45deg);
    margin-left: -4px;
    margin-top: -6px;
    right: 40%;
  }
  .swiper-button-prev::after {
    transform: rotate(-135deg);
    margin-left: -8px;
    margin-top: -6px;
    left: 60%;
  }
  .swiper-button-next:hover,
  .swiper-button-prev:hover {
    background: #333;
  }
}
.future_box .future_info {
  width: 100%;
  display: flex;
  justify-content: space-between;

  > img {
    width: 55%;
  }

  .future_ul {
    width: 44%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0.75rem;
    box-sizing: border-box;

    > li {
      width: 100%;
      height: 120px;
      display: flex;
      align-items: center;
      > img {
        width: 113px;
        height: 130px;
      }

      > .li_content {
        margin-left: 20px;
        text-align: left;
        > h2 {
          font-size: 1.25rem;
          font-weight: 600;
          color: rgba(9, 15, 25, 1);
          letter-spacing: 1px;
        }
        > p {
          font-size: 1rem;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          margin-top: 20px;
          letter-spacing: 1px;
        }
      }
    }
    > li:hover {
      box-shadow: 0px 1px 30px rgba(0, 0, 0, 0.1);
    }
  }
}
.history_box .history_info {
  width: 100%;

  .history_top {
    width: 800px;
    height: 280px;
    margin: 0 auto 70px;
    display: flex;
    align-items: center;
    box-shadow: 0px 1px 30px rgba(0, 0, 0, 0.1);

    > img {
      width: 360px;
      height: 280px;
    }

    > div {
      text-align: left;
      margin-left: 50px;
      > h2 {
        font-size: 1.5rem;
        font-weight: 400;
        color: rgba(29, 34, 42, 1);
      }
      > span {
        display: block;
        width: 30px;
        height: 6px;
        background: rgba(50, 105, 255, 1);
        margin: 14px 0 40px;
      }
      > p {
        width: 330px;
        height: 80px;
        font-size: 1rem;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        display: -webkit-box;
        -webkit-line-clamp: 3; /* 核心：显示3行 */
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        /* 建议加上，避免行高不统一导致计算错误 */
        line-height: 1.6;
        word-break: break-all;
      }
    }
  }

  .history_list {
    width: 80%;
    margin: 0 auto;
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    > li {
      text-align: center;
      cursor: pointer;

      > div {
        width: 60px;
        height: 60px;
        margin: 0 auto;
        > img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
        }
      }
      > p {
        font-size: 0.875rem;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        margin-top: 12px;
      }
    }
    > li.active {
      > div {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        box-shadow: 0 0 10px rgba(64, 158, 255, 0.3);
        > img {
          width: 80px;
          height: 80px;
        }
      }
    }
  }
}

.page_nav {
  width: 100%;
  position: relative;
  transition: all 0.3s ease;
  > ul {
    width: 980px;
    height: 60px;
    border-radius: 50px;
    background: #fff;
    box-shadow: 0px 1px 30px rgba(0, 0, 0, 0.1);
    margin: 0 auto;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    position: absolute;
    bottom: 70px;
    left: 50%;
    transform: translateX(-50%);

    > li {
      width: 190px;
      line-height: 50px;
      opacity: 1;
      border-radius: 25px;
      box-sizing: border-box;
      font-size: 1.125rem;
      font-weight: 400;
      cursor: pointer;
    }
    > li.active {
      background: rgba(228, 245, 255, 1);
      color: rgba(7, 70, 255, 1);
      border: 1px solid rgba(228, 245, 255, 1);
    }
  }
  &.fixed {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 998;
    padding: 0.625rem 0;
    > ul {
      position: relative;
      bottom: auto;
      left: auto;
      transform: none;
    }
  }
}
</style>
